var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h2',{staticClass:"my-8 text-xl sm:text-3xl",style:(`---color: ${_vm.color}; ---font-weight: ${_vm.weight}`)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }